module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "latest-posts panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("\n            Latest Forum Posts\n            "), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('The most recent posts from all threads in the forum.'),
      expression: "'The most recent posts from all threads in the forum.'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(_vm.posts) ? _vm._m(0) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('scroll-area', {
    ref: "scrollbar"
  }, [_c('ul', {
    ref: "postList",
    staticClass: "post-list"
  }, _vm._l((_vm.posts), function(post) {
    return _c('li', {
      key: post.threadId + '_' + post.id
    }, [_c('ForumPostResult', {
      attrs: {
        "post": post,
        "thread": post.thread
      }
    }, [_c('template', {
      attrs: {
        "slot": "post-content"
      },
      slot: "post-content"
    }, [_c('div', {
      staticClass: "post-content-html",
      domProps: {
        "innerHTML": _vm._s(post.content)
      }
    })])], 2)], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "forum-link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'forum-home'
      }
    }
  }, [_vm._v("\n                    Go to forum\n                ")])], 1)])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f099e81c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/LatestPosts.vue
// module id = 2116
// module chunks = 2